import { Component, inject, Input, OnInit } from '@angular/core';
import { PageContent } from '@/shared/interfaces';
import { ButtonLevel } from '@/shared/interfaces/button.interface';
import { ButtonModule, IconModule } from '@virginmediao2/momentum-angular';
import { AnalyticsService } from '@/shared/services/analytics.service';

@Component({
  selector: 'vm-api-error',
  templateUrl: './api-error.component.html',
  styleUrls: ['./api-error.component.scss'],
  standalone: true,
  imports: [ButtonModule, IconModule],
})
export class ApiErrorComponent implements OnInit {
  @Input() errorContent = {
    icon: 'frown',
    iconColor: '#5F2878',
    iconWeight: 'light',
    subtitle: 'Sorry, we can’t check the service status in your area right now',
    info: 'Please try again later or check out our handy tips instead.',
    cta: [
      {
        uid: 'help',
        url: 'help',
        label: 'View our handy tips',
        linkUrl: 'https://www.virginmedia.com/help/broadband/virgin-media-wifi-not-working',
        classes: '',
        buttonLevel: ButtonLevel.TERTIARY,
      },
    ],
  };
  @Input() pageContent: PageContent = { pageHeading: '' } as PageContent;
  @Input() routerLinkText = 'Back';
  private analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    this.analyticsService.trackPageView('', 'care|faults|dashboard|error');
  }

  goToNextPage() {
    const link = this.errorContent.cta[0].linkUrl;
    window.location.href = link;
  }
}
